import Armonthome1 from '../../Media/homeimages/Armont.webp'
import Armonthome2 from '../../Media/homeimages/Armont.webp'





const Armonthomeimages =[
Armonthome1,Armonthome2
]

export default Armonthomeimages;